import { useQuery } from 'react-query'
import { QUERY_KEYS } from 'src/constants'
import { rewardPointsService } from 'src/services/reward-points.service'

const useGetScanToEarnReward = () => {
  return useQuery(
    [QUERY_KEYS.SCAN_TO_EARN_PRICE],
    () => rewardPointsService.getScanToEarnReward(),
    {
      keepPreviousData: true,
      onSuccess: () => {},
    },
  )
}

export { useGetScanToEarnReward }
